import {Component, HostListener, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';
import {filter, map} from 'rxjs/operators';
import {WimdStore} from '../wimdStore';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-wimd-chart',
  templateUrl: './wimd-chart.component.html',
  styleUrls: ['./wimd-chart.component.css']
})
export class WimdChartComponent implements OnInit {

  private chart: Highcharts.Chart;
  private subscriptions = new Subscription();

  constructor(private wimdStore: WimdStore) {
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.setChartSize();
  }

  ngOnInit() {
    this.chart = Highcharts.chart('container', this.getChartOptions());
    this.setChartSize();
    this.wimdStoreStateSubscription();

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private wimdStoreStateSubscription(): void {
    this.subscriptions.add(
      this.wimdStore.currentState
        .pipe(
          filter(state => this.isValidState(state)),
          map((state) => (this.mapStateToChartData(state))),
          map((dataObject: any) => this.applyFilters(dataObject))
        )
        .subscribe({
          next: (values) => this.updateChart(values)
        })
    );
  }

  private updateChart(values: { seriesData: any[], zonesArray: any[]; }): void {
    this.chart.update({
      series: [{
        id: 'main',
        data: values.seriesData,
        zoneAxis: 'x',
        zones: values.zonesArray,
        type: 'column'
      }]
    });
  }

  private setChartSize() {
    let width = window.innerWidth;
    let height = window.innerHeight / 4;
    this.chart.setSize(width - 20, height);
  }

  private isValidState(state: any): boolean {
    return state && state.filters && state.chart;
  }

  private mapStateToChartData(state: any): any {
    return {filters: state.filters, data: state.chart};
  }

  private applyFilters(dataObject: any): any {
    let seriesData = dataObject.data['all'];
    let zonesArray;
    if (dataObject.filters.thresholds.length > 0) {
      seriesData = seriesData.filter(
        (value) => this.minValueValidator(dataObject.filters.thresholds[0], value[0])
      );
      zonesArray = this.setThresholdZones(dataObject.filters.thresholds);
    }
    return {seriesData, zonesArray};
  }

  private minValueValidator(minThreshold, passage): any {
    return (minThreshold && minThreshold !== '') ? minThreshold - 2 <= passage : true;
  }

  private setThresholdZones(thresholds: any): any {
    let zonesArray: any[] = [{
      value: 1000,
      color: 'yellow'
    }, {
      value: 1000,
      color: 'orange'
    }, {
      value: 1000,
      color: 'red'
    }];
    zonesArray.forEach(
      (el, index) => {
        if (thresholds[index + 1]) {
          zonesArray[index].value = thresholds[index + 1];
        }
      }
    );
    return zonesArray;
  }

  private getChartOptions(): any {
    return {
      chart: {
        type: 'column',
        width: 3000,
        height: 400,
        backgroundColor: 'transparent',
        zIndex: 0,
        style: {
          fontFamily: 'Times New Roman'
        }
      },
      tooltip: {
        hideDelay: 100,
        shadow: false,
        borderRadius: 0,
        backgroundColor: '#ffffff',
        borderColor: '#212121',
        animation: false,
        formatter: function (): any {
          return 'Y: ' + this.y + '<br>X: ' + this.x;
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        startOnTick: false,

        title: {
          text: 'Weight (tons)'
        },
        labels: {
          rotation: -90,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        },
        tickInterval: 4
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Frequency'
        },
        labels: {
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        },
      },
      legend: {
        enabled: false
      },
      series: [{
        id: 'main',
        data: {},
        zoneAxis: 'x',
        color: '#a0bcd8'
      }],
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 1,
          groupPadding: 0,
          shadow: false
        }
      },
      credits: {
        enabled: false
      }
    };
  }

}
